import { createServer } from "miragejs";
import data from "@/random-data.json";

export default function() {
  createServer({
    routes() {
      this.namespace = "api";

      // Gets a random number of random entries
      this.get("/search", () => {
        const results = [];
        const size = Math.random() * data.length;
        for (let i = 0; i < size; i++) {
          results.push(data[Math.floor(Math.random() * data.length)]);
        }
        return results;
      });

      this.get("/random-data", () => {
        return data;
      });

      // If your API requests go to an external domain, pass those through by
      // specifying the fully qualified domain name
      // https://miragejs.com/docs/getting-started/overview/#passthrough
      this.passthrough("https://globe.gl/**");
    }
  });
}
